import isMobileJS from 'ismobilejs';
import Cookies from 'js-cookie';

import Forms from './modules/Forms';
import Navigation from './modules/Navigation';
import ContactModal from './modules/ContactModal';
import NewsletterModal from './modules/NewsletterModal';
import YouTubeModal from './modules/YouTubeModal';

/* Site Controller
 * =========================
 * This controller is loaded on every page. For any activity that needs to execute on all
 * page please implement here.
 */

 /* global Back, TweenMax, TimelineMax, Power2, Elastic, Hammer, TweenLite, ga */


export default class SiteController {

  constructor(options) {

    this.options = options;
    console.log('SITE CONTROLLER');

    // init the site navigation
    this.navigation = new Navigation(options);

    // footer subscribe form
    this.forms = new Forms(this.options);

    // contact overlay modal
    this.contact = new ContactModal();

    // contact overlay modal
    this.newsletter = new NewsletterModal();

    // youtube video player overlay
    if ( $('.cta--video').length > 0 ) {
      this.youtube = new YouTubeModal();
    }

    if ( isMobileJS.any ) {
      $('body').removeClass('notouch');
    }


    // show a11y menu on tab focus
    $('.a11y__skipMenu>a').focus( () => {
      $('.a11y__skipMenu').css('top', '0px');
    });

    $('.a11y__skipMenu>a').blur( () => {
      $('.a11y__skipMenu').css('top', '');
    });

    $('.content__arrow').click( (e) => {
      const st = $(e.currentTarget).parent().next().offset().top;
      $( 'html, body').animate({ scrollTop: st });
    });

    $('.socialLinks--share').click( (e) => {
      if ( !isMobileJS.any ) {
        e.preventDefault();

        window.open(
          $(e.currentTarget).attr('href'),
          'Share this',
          'status,width=640,height=480'
        );
      }
    } );

    if ( $(window).scrollTop() > 500 ) {
      $('.menuSystem').removeClass('intro');
    } else {
      this.transitionIn();
    }

    $('#footer_newsletter').submit( (e) => { this.submitForm(e); } );
    $('#header_newsletter').submit( (e) => { this.submitHeaderForm(e); } );

    if ( Cookies.get('show_nlsignup2') === undefined && $(window).scrollTop() < 100 ) {
      setTimeout( () => {
        console.log('OPENING NEWSLETTER');
        this.newsletter.openNewsletter();
        //$('.nlSignup').addClass('is-active');
        //$('.menuContainer, .siteContainer, .navButtonsBG').addClass('is-pushedDown');
        Cookies.set('show_nlsignup2', '1', { expires: 1 });
        ga('send', 'event', 'NL Signup Open', 'close button');
      }, 1000);
    }

    $('.nlSignup .closeSignup').click( () => {
      this.closeSignup();
      ga('send', 'event', 'NL Signup Close', 'close button');
    });

    $(window).scroll( e => this.handleScroll(e) );

  }

  handleScroll() {
    if ( $(window).scrollTop() > 100 && $('.nlSignup').hasClass('is-active') ) {
      this.closeSignup();
      ga('send', 'event', 'NL Signup Close', 'scroll');
    }
  }

  closeSignup() {
    $('.nlSignup').removeClass('is-active');
    $('.menuContainer, .siteContainer, .navButtonsBG').removeClass('is-pushedDown');
    Cookies.set('show_nlsignup', '1', { expires: 30 });
  }


  transitionIn() {

    const tl = new TimelineMax();
    tl.add('s1');
    tl.add( TweenMax.fromTo( $('.logoNav'), 1, { y: -20, opacity: 0 }, { opacity: 1, y: 0 } ), 's1+=0.7' );
    tl.add( TweenMax.fromTo( $('.burger'), 1, { y: -20 }, { opacity: 1, y: 0 } ), 's1+=0.7' );

    tl.play();

  }

  submitHeaderForm(e) {

    if ( !this.validateFooterForm() ) {
      e.preventDefault();
      ga('send', 'event', 'NL Signup', 'fail validation');
    } else {
      this.closeSignup();
      ga('send', 'event', 'NL Signup', 'success');
    }

  }

  submitForm(e) {

    if ( !this.validateFooterForm() ) {
      e.preventDefault();
    } else {
      setTimeout( () => {
        $('.form-response').text('Thank You!');
      }, 500 );
    }

  }

  validateFooterForm() {
    let clean = true;

    if ( $('#mce-EMAIL').val() === '' || $('#mce-EMAIL').parent().hasClass('has-error') ) {
      console.log('HERE!');
      clean = false;
      $('#mce-EMAIL').parent().addClass('has-error');
    } else {
      $('#mce-EMAIL').parent().removeClass('has-error');
    }

    return clean;
  }


}



// WEBPACK FOOTER //
// ./js/SiteController.js